// Ported from sn-plugin2 packages/embed-contract/src/snippet.ts @ 54685d64 — keep in step with the plugin.
import { PLUGIN_EMBED_SCRIPT_URL } from '../constants'
import type { EmbedSnippetVariant } from '../types'
import type { PluginPublicCfg } from '../types/embedSettings'
import {
  escapeAttribute,
  snippetDataAttributes,
} from './embedSnippetAttributes'

interface EmbedSnippetInput {
  pluginKey: string
  cfg: PluginPublicCfg
}

const LOADER = `<script src="${PLUGIN_EMBED_SCRIPT_URL}" async></script>`

const buildAttributeSnippet = ({
  pluginKey,
  cfg,
}: EmbedSnippetInput): string => {
  const attributes = Object.entries(snippetDataAttributes(pluginKey, cfg))
    .map(([name, value]) => `${name}="${escapeAttribute(value)}"`)
    .join('\n     ')
  return `<div data-sportninja\n     ${attributes}></div>\n${LOADER}`
}

const buildScriptSnippet = ({ pluginKey, cfg }: EmbedSnippetInput): string => {
  // `<` as < (still valid JSON) so a value like `</script>` can't close the inline script.
  const options = JSON.stringify({ key: pluginKey, ...cfg }, null, 2).replace(
    /</g,
    '\\u003c'
  )
  return [
    '<div id="sportninja"></div>',
    LOADER,
    '<script>',
    '  window.SportNinja = window.SportNinja || [];',
    `  SportNinja.push(['mount', '#sportninja', ${options.replace(
      /\n/g,
      '\n  '
    )}]);`,
    '</script>',
  ].join('\n')
}

/**
 * The HTML a league pastes into its website: the key and the public cfg built
 * from the snippet builder's settings.
 */
export const buildEmbedSnippet = (
  input: EmbedSnippetInput,
  variant: EmbedSnippetVariant
): string =>
  variant === 'noScript'
    ? buildAttributeSnippet(input)
    : buildScriptSnippet(input)
